import { TranslateService } from "@ngx-translate/core";
import { type } from "os";

export const DIALOG_REFRESH_INTERVAL = 1000; // msec

export const MSG_TYPE_NON_SUPPORT = -1;
export const MSG_TYPE_SENSOR = 1;
export const MSG_TYPE_PLOT = 2;
export const MSG_TYPE_TRACK = 3;
export const MSG_TYPE_USER_ACTION = 4;
export const MSG_TYPE_USER_ACTION_STATUS = 5;
export const MSG_TYPE_ERROR_NOTIFICATIONS = 6; 
export const MSG_TYPE_IMPACTPOINT = 7; 
export const MSG_TYPE_IMPACTPOLYGON = 8;
export const MSG_TYPE_NAI = 9;
export const MSG_TYPE_CLSARM = 10;
export const MSG_TYPE_THREAT_POLYGON = 11;
export const MSG_TYPE_DTM_HEIGHT = 12;
export const MSG_TYPE_EXTIP = 13;
export const MSG_TYPE_PARAMS = 14;
export const MSG_TYPE_SNS_VECTOR = 15;
export const MSG_TYPE_PLAYBACK = 16;

export type SIGNAL_R_MSG_TYPE = 'MSG_TYPE_SENSOR' | 'MSG_TYPE_SNS_VECTOR';


// export const MSG_TYPE_PLOTS = 9; // multiple plots (array)
// export const MSG_TYPE_ANGULAR_TRACK = 7;
//export const MSG_TYPE_ANGULAR_TRACKS = 8; // multiple angular tracks (array)

export const MAP_DISPLAY_ELEMENT_ROADS = 0;
export const MAP_DISPLAY_ELEMENT_SECONDARY_ROADS = 1;
export const MAP_DISPLAY_ELEMENT_MAIN_CITIES = 2;
export const MAP_DISPLAY_ELEMENT_SECONDARY_CITIES = 3;
export const MAP_DISPLAY_ELEMENT_GRID = 4;
export const MAP_DISPLAY_ELEMENT_FREE_DRAWINGS = 5;
export const MAP_DISPLAY_ELEMENT_LAST = MAP_DISPLAY_ELEMENT_FREE_DRAWINGS;

export const POINT_DISPLAY_ELEMENT_LABEL = 0;
export const POINT_DISPLAY_ELEMENT_LAST = POINT_DISPLAY_ELEMENT_LABEL;

export const SNS_TYPE_ELEMENT_REGULAR = 0;
export const SNS_TYPE_ELEMENT_ACOUSTIC = 1;
export const SNS_TYPE_ELEMENT_VIDEO = 2;
export const SNS_TYPE_ELEMENT_LAST = SNS_TYPE_ELEMENT_VIDEO;

export const ACOUSTIC_ELEMENT_LINE = 0;
export const ACOUSTIC_ELEMENT_TEXT = 1;
export const ACOUSTIC_ELEMENT_LAST = ACOUSTIC_ELEMENT_TEXT;

export const TRACK_DISPLAY_ELEMENT_HISTORY = 0;
export const TRACK_DISPLAY_ELEMENT_LAST = TRACK_DISPLAY_ELEMENT_HISTORY;

export const SYS_TRACK_DISPLAY_ELEMENT_TRACK = 0;
export const SYS_TRACK_DISPLAY_ELEMENT_VECTOR = 1;
export const SYS_TRACK_DISPLAY_ELEMENT_LABEL = 2;
export const SYS_TRACK_DISPLAY_ELEMENT_AUX_LABEL = 3;
export const SYS_TRACK_DISPLAY_ELEMENT_IP = 4;
export const SYS_TRACK_DISPLAY_ELEMENT_TP = 5;
export const SYS_TRACK_DISPLAY_ELEMENT_LAST = SYS_TRACK_DISPLAY_ELEMENT_TP + 1;

export const SNS_TRACK_DISPLAY_ELEMENT_TRACK = 0;
export const SNS_TRACK_DISPLAY_ELEMENT_VECTOR = 1;
export const SNS_TRACK_DISPLAY_ELEMENT_LABEL = 2;
export const SNS_TRACK_DISPLAY_ELEMENT_DUMMY = 3;
export const SNS_TRACK_DISPLAY_ELEMENT_LAST = SNS_TRACK_DISPLAY_ELEMENT_DUMMY;

export const ANG_TRACK_DISPLAY_ELEMENT_TRACK = 0;
export const ANG_TRACK_DISPLAY_ELEMENT_LAST = ANG_TRACK_DISPLAY_ELEMENT_TRACK;

export const CLS_TRACK_DISPLAY_ELEMENT_TBM = 0;
export const CLS_TRACK_DISPLAY_ELEMENT_ABT = 1;
export const CLS_TRACK_DISPLAY_ELEMENT_LAST = CLS_TRACK_DISPLAY_ELEMENT_ABT;

export const IDENTITY_TRACK_DISPLAY_ELEMENT_LAST = 7;
export const PLOT_TYPES = 5;

// Local actions
export const USER_ACTION_ARO = 1000;
export const USER_ACTION_DROP = 1001;
export const USER_ACTION_RULER = 1002;
export const USER_ACTION_RULER_REMOVE = 1003;
export const USER_ACTION_RULER_REVERSE = 1004;
export const USER_ACTION_RULER_REMOVE_ALL = 1005;
export const USER_ACTION_HISTORY = 1006;
export const USER_ACTION_DYNAMIC_CENTER = 1007;
export const USER_ACTION_SIDE_VIEW = 1008;
export const USER_ACTION_FORCE_SEND_POLY = 1009;
// export const USER_ACTION_CREATE_TRACK = 1009;
// export const USER_ACTION_PIN_POINT = 1010;
// export const USER_ACTION_CENTER = 1011;
export const USER_ACTION_CREATE_NAT_NAI = 1012;
export const USER_ACTION_DELETE_NAT_NAI = 1013;
export const USER_ACTION_UPDATE_NAT_NAI = 1014;
export const USER_ACTION_NAT_NAI_TURN_ON = 1015;
export const USER_ACTION_NAT_NAI_TURN_OFF = 1016;
export const USER_ACTION_EXIP_REMOVE = 1017;
export const USER_ACTION_EXIP_EDIT = 1018;
export const USER_ACTION_ENABLE_VECTOR_HISTORY = 1019;
export const USER_ACTION_DISABLE_VECTOR_HISTORY = 1020;
export const USER_ACTION_OPEN_SOUND_PLAYER = 1021;
export const USER_ACTION_OPEN_VIDEO_PLAYER = 1022;


export const LOCAL_STORAGE_HEIGHT_KEY = "HeightMapPoint";
export const LOCAL_STORAGE_SHOW_DTM_KEY = "ShowDTM";
export const LOCAL_STORAGE_NEW_ERR_NOTIFICATION = "NewNotification";
export const LOCAL_STORAGE_ALL_ERR_NOTIFICATION = "AllErrorNotifications";
export const LOCAL_STORAGE_CURRENT_LANGUAGE = "ArmLanguage";

export class Constants {
  translations: any = [];

  msgTypeTitle(msgType: number): string {
    switch (msgType) {
      case MSG_TYPE_SENSOR: return this.translations['SENSOR'];
      case MSG_TYPE_PLOT: return this.translations['PLOT'];
      case MSG_TYPE_TRACK: return this.translations['TRACK'];
      case MSG_TYPE_USER_ACTION: return this.translations['USER_ACTION'];
      case MSG_TYPE_USER_ACTION_STATUS: return this.translations['USER_ACTION_STATUS'];
      default: return '';
    }
  }

  mapDisplayElementCount(): number {
    return MAP_DISPLAY_ELEMENT_LAST + 1;
  }

  mapDisplayElementTitle(element: number): string {
    switch (element) {
      case MAP_DISPLAY_ELEMENT_ROADS: return this.translations['MAP_DISPLAY_ELEMENT_ROADS'];
      case MAP_DISPLAY_ELEMENT_SECONDARY_ROADS: return this.translations['MAP_DISPLAY_ELEMENT_SECONDARY_ROADS'];
      case MAP_DISPLAY_ELEMENT_MAIN_CITIES: return this.translations['MAP_DISPLAY_ELEMENT_MAIN_CITIES'];
      case MAP_DISPLAY_ELEMENT_SECONDARY_CITIES: return this.translations['MAP_DISPLAY_ELEMENT_SECONDARY_CITIES'];
      case MAP_DISPLAY_ELEMENT_GRID: return this.translations['MAP_DISPLAY_ELEMENT_GRID'];
      case MAP_DISPLAY_ELEMENT_FREE_DRAWINGS: return this.translations['MAP_DISPLAY_ELEMENT_FREE_DRAWINGS'];
      default: return '';
    }
  }
  
  pointDisplayElementCount(): number {
    return POINT_DISPLAY_ELEMENT_LAST;
  }

  pointDisplayElementTitle(element: number): string {
    switch (element) {
      case POINT_DISPLAY_ELEMENT_LABEL: return this.translations['POINT_DISPLAY_ELEMENT_LABEL'];
      default: return '';
    }
  }

  trackDisplayElementCount(): number {
    return TRACK_DISPLAY_ELEMENT_LAST + 1;
  }

  trackDisplayElementTitle(element: number): string {
    switch (element) {
      case TRACK_DISPLAY_ELEMENT_HISTORY: return this.translations['TRACK_DISPLAY_ELEMENT_HISTORY'];
      default: return '';
    }
  }

  sysTrackDisplayElementCount(): number {
    return SYS_TRACK_DISPLAY_ELEMENT_LAST;
  }

  ipTrackDisplayElementCount(): number {
    return SYS_TRACK_DISPLAY_ELEMENT_LAST;
  }

  sysTrackDisplayElementTitle(element: number): string {
    switch (element) {
      case SYS_TRACK_DISPLAY_ELEMENT_TRACK: return this.translations['SYS_TRACK_DISPLAY_ELEMENT_TRACK'];
      case SYS_TRACK_DISPLAY_ELEMENT_VECTOR: return this.translations['SYS_TRACK_DISPLAY_ELEMENT_VECTOR'];
      case SYS_TRACK_DISPLAY_ELEMENT_LABEL: return this.translations['SYS_TRACK_DISPLAY_ELEMENT_LABEL'];
      case SYS_TRACK_DISPLAY_ELEMENT_AUX_LABEL: return this.translations['SYS_TRACK_DISPLAY_ELEMENT_AUX_LABEL'];
      case SYS_TRACK_DISPLAY_ELEMENT_IP: return this.translations['SYS_TRACK_DISPLAY_ELEMENT_IP'];
      case SYS_TRACK_DISPLAY_ELEMENT_TP: return this.translations['SYS_TRACK_DISPLAY_ELEMENT_TP'];
      default: return '';
    }
  }

  snsTrackDisplayElementCount(): number {
    return SNS_TRACK_DISPLAY_ELEMENT_LAST + 1;
  }

  snsTrackDisplayElementTitle(element: number): string {
    switch (element) {
      case SNS_TRACK_DISPLAY_ELEMENT_TRACK: return this.translations['SNS_TRACK_DISPLAY_ELEMENT_TRACK'];
      case SNS_TRACK_DISPLAY_ELEMENT_VECTOR: return this.translations['SNS_TRACK_DISPLAY_ELEMENT_VECTOR'];
      case SNS_TRACK_DISPLAY_ELEMENT_LABEL: return this.translations['SNS_TRACK_DISPLAY_ELEMENT_LABEL'];
      case SNS_TRACK_DISPLAY_ELEMENT_DUMMY: return null;
      default: return '';
    }
  }

  angTrackDisplayElementCount(): number {
    return ANG_TRACK_DISPLAY_ELEMENT_LAST + 1;
  }

  angTrackDisplayElementTitle(element: number): string {
    switch (element) {
      case ANG_TRACK_DISPLAY_ELEMENT_TRACK: return this.translations['ANG_TRACK_DISPLAY_ELEMENT_TRACK'];
      default: return '';
    }
  }

  clsTrackDisplayElementCount(): number {
    return CLS_TRACK_DISPLAY_ELEMENT_LAST + 1;
  }

  clsTrackDisplayElementTitle(element: number): string {
    switch (element) {
      case CLS_TRACK_DISPLAY_ELEMENT_TBM: return this.translations['CLS_TRACK_DISPLAY_ELEMENT_TBM'];
      case CLS_TRACK_DISPLAY_ELEMENT_ABT: return this.translations['CLS_TRACK_DISPLAY_ELEMENT_ABT'];
      default: return '';
    }
  }

  snsTypeDisplayElementCount(): number {
    return SNS_TYPE_ELEMENT_LAST + 1;
  }

  snsTypeDisplayElementTitle(element: number): string {
    switch (element) {
      case SNS_TYPE_ELEMENT_REGULAR: return 'Regular';
      case SNS_TYPE_ELEMENT_ACOUSTIC: return 'Acoustic';
      case SNS_TYPE_ELEMENT_VIDEO: return 'Video';
      default: return '';
    }
  }
  snsTypeDisplayElementOption(element: number): boolean {
    switch (element) {
      case SNS_TYPE_ELEMENT_REGULAR: return true;
      case SNS_TYPE_ELEMENT_ACOUSTIC: return true;
      case SNS_TYPE_ELEMENT_VIDEO: return true;
      default: return true;
    }
  }

  acousticDisplayElementCount(): number {
    return ACOUSTIC_ELEMENT_LAST + 1;
  }

  acousticDisplayElementTitle(element: number): string {
    switch (element) {
      case ACOUSTIC_ELEMENT_LINE: return 'Line';
      case ACOUSTIC_ELEMENT_TEXT: return 'Text';
      default: return '';
    }
  }

  identityTrackDisplayElementCount(): number {
    /*let hostilities = this.translations['IDENTITY_VALUES'];
    if (!hostilities)
      return 0;
    return hostilities.length;*/
    return IDENTITY_TRACK_DISPLAY_ELEMENT_LAST;
  }

  identityTrackDisplayElementTitle(element: number): string {
    let hostilities = this.translations['IDENTITY_VALUES'];
    if (!hostilities)
      return '';
    return hostilities[element];
  }

  userActionTitle(userAction: number): string {
    switch (userAction) {
      case USER_ACTION_ARO: return this.translations['USER_ACTION_ARO'];
      case USER_ACTION_DROP: return this.translations['USER_ACTION_DROP'];
      case USER_ACTION_RULER: return this.translations['USER_ACTION_RULER'];
      case USER_ACTION_RULER_REMOVE: return this.translations['USER_ACTION_RULER_REMOVE'];
      case USER_ACTION_RULER_REVERSE: return this.translations['USER_ACTION_RULER_REVERSE'];
      case USER_ACTION_RULER_REMOVE_ALL: return this.translations['USER_ACTION_RULER_REMOVE_ALL'];
      case USER_ACTION_HISTORY: return this.translations['USER_ACTION_HISTORY'];
      case USER_ACTION_DYNAMIC_CENTER: return this.translations['USER_ACTION_DYNAMIC_CENTER'];
      case USER_ACTION_SIDE_VIEW: return this.translations['USER_ACTION_SIDE_VIEW'];
      case USER_ACTION_EXIP_REMOVE: return this.translations['USER_ACTION_EXIP_REMOVE'];
      case USER_ACTION_EXIP_EDIT: return this.translations['USER_ACTION_EXIP_EDIT'];
      case USER_ACTION_ENABLE_VECTOR_HISTORY: return this.translations['USER_ACTION_ENABLE_VECTOR_HISTORY'];
      case USER_ACTION_DISABLE_VECTOR_HISTORY: return this.translations['USER_ACTION_DISABLE_VECTOR_HISTORY'];
      case USER_ACTION_OPEN_SOUND_PLAYER: return "Open Sound Player";
      case USER_ACTION_OPEN_VIDEO_PLAYER: return "Open Video Player";
      case USER_ACTION_FORCE_SEND_POLY: return this.translations['USER_ACTION_FORCE_SEND_POLY'];
      // case USER_ACTION_CREATE_TRACK: return this.translations['CREATE_TRACK'];
      // case USER_ACTION_PIN_POINT: return this.translations['PIN_POINT'];
      // case USER_ACTION_CENTER: return this.translations['CENTER'];;
      case USER_ACTION_CREATE_NAT_NAI: return this.translations['CREATE_ALERT_POLYGON'];
      case USER_ACTION_NAT_NAI_TURN_ON: return this.translations['NAT_NAI_TURN_ON'];
      case USER_ACTION_NAT_NAI_TURN_OFF: return this.translations['NAT_NAI_TURN_OFF'];
      case USER_ACTION_UPDATE_NAT_NAI: return this.translations['USER_ACTION_UPDATE_NAT_NAI'];
      case USER_ACTION_DELETE_NAT_NAI: return this.translations['USER_ACTION_DELETE_NAT_NAI'];


      case 10000: return "Sensor Bias";
      default: {
        return "This Is A Bug";
      }
    }
  }

  plotTypeDisplayElementCount(): number {
    /*let hostilities = this.translations['IDENTITY_VALUES'];
    if (!hostilities)
      return 0;
    return hostilities.length;*/
    return PLOT_TYPES;
  }

}

export var constsMngr: Constants = null;

export function initConstants(constants: Constants, translateService: TranslateService) {
  constsMngr = constants;
  translateService.get('CONSTS').subscribe(translations => 
  {
    constsMngr.translations = translations;
  });
}
